module.exports = __webpack_public_path__ + "h5/img/open.6215d514.png";